<template>
  <!-- 无人机/车历史详情的地图 -->
  <div>
    <div v-if="hasData" id="container"/>
    <div v-else>
      <img src="@/assets/photos/1920.png" style="height: 440px" alt="">
    </div>
  </div>

</template>

<script>
import AMap from "AMap"; // 引入高德地图AMap
import { mapState } from "vuex";
import "@/assets/css/navigation.css";
import { getHistoryMapTrace } from "@api/navigation";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "TraceMap",
  props: {},
  data() {
    return {
      hasData: true
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      allPosition: "allPosition",
      patient: "showOrEditPatientInfo"

    }),
  },
  mounted() {
    // this.map = null; // 高德地图map对象
    this.initMap();
  },
  beforeUnmount() {
    // this.map?.destroy();
    // this.map = null;
  },
  methods: {
    async initMap() {
      try {
        const { id } = this.patient;
        const { code, data, msg, len } = await getHistoryMapTrace(id);
        if (code !== 200) {
          this.hasData = false;
          showWindowMessage(3, msg, this);
          return;
        }
        // 拿到地图的数据的一半的值作为中心点
        const middle = data[parseInt(len / 2)];
        // fixme: 临时的time
        const start = parseInt(data[0].time);
        data.forEach((trace, index) => {
          trace.x = trace.longitude;
          trace.y = trace.dimension;
          trace.sp = trace.speed;
          trace.ag = trace["read_north_angle"];
          if (index) {
            trace.tm = trace.time - start;
          } else {
            trace.tm = start;
          }
        });
        var map = new AMap.Map("container", {
          resizeEnable: true, // 是否监控地图容器尺寸变化
          zoom: 16, // 初始化地图层级
          center: [middle.longitude, middle.dimension], // 初始化地图中心点
        });
        var pathParam = data;

        // const path = [
        //   [113.438093, 23.166384],
        //   [113.439093, 23.166684],
        //   [113.441093, 23.166384],
        //   [113.442094, 23.166364],
        //   [113.443093, 23.166684],
        //   [113.444093, 23.166784],
        //   [113.445093, 23.166284],
        // ];
        var path1 = [];
        for (var i = 0; i < pathParam.length; i += 1) {
          path1.push([pathParam[i].x, pathParam[i].y]);
        }
        var oldLine = new AMap.Polyline({
          path: path1,
          strokeWeight: 8,
          strokeOpacity: 1,
          strokeColor: "red"
        });
        map.add(oldLine);
        map.setFitView();
        // var graspRoad;
        // if (!graspRoad) {
        //   graspRoad = new AMap.GraspRoad();
        // }
        // graspRoad.driving(pathParam, function(error, result) {
        //   if (!error) {
        //     var path2 = [];
        //     var newPath = result.data.points;
        //     for (var i = 0; i < newPath.length; i += 1) {
        //       path2.push([newPath[i].x, newPath[i].y]);
        //     }
        //     var newLine = new AMap.Polyline({
        //       path: path2,
        //       strokeWeight: 8,
        //       strokeOpacity: 0.8,
        //       strokeColor: "#0091ea",
        //       showDir: true
        //     });
        //     map.add(newLine);
        //   }
        // });

        // this.map = new AMap.Map("container", {
        //   resizeEnable: true, // 是否监控地图容器尺寸变化
        //   zoom: 15, // 初始化地图层级
        //   center: [middle.longitude, middle.dimension], // 初始化地图中心点
        // });
        //
        // var polyline = new AMap.Polyline({
        //   path: path,
        //   isOutline: true,
        //   outlineColor: "#ffeeff",
        //   borderWeight: 3,
        //   strokeColor: "#3366FF",
        //   strokeOpacity: 1,
        //   strokeWeight: 6,
        //   // 折线样式还支持 'dashed'
        //   strokeStyle: "solid",
        //   // strokeStyle是dashed时有效
        //   strokeDasharray: [10, 5],
        //   lineJoin: "round",
        //   lineCap: "round",
        //   zIndex: 50,
        // });
        //
        // polyline.setMap(this.map);
        // 缩放地图到合适的视野级别
        // this.map.setFitView(polyline);
      } catch (e) {
        showWindowMessage(3, e, this);

      }
    },
  },
};
</script>

<style lang="scss" scoped>
#container {
  width: 800px;
  height: 600px;
}

</style>
